import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type ChatMessageTextRowProps = {
  children: ReactNode;
  meta: ReactNode;
  className?: string;
};

/**
 * Texto + horário no estilo WhatsApp Web: meta com float-right na mesma
 * caixa de linha do texto (última linha quando há quebra). Sem spacer fixo.
 */
export function ChatMessageTextRow({ children, meta, className }: ChatMessageTextRowProps) {
  return (
    <span
      className={cn(
        "inline-block w-fit max-w-full min-w-0 leading-snug",
        "[&_p]:inline [&_p]:whitespace-pre-wrap [&_p]:break-words [&_p]:[overflow-wrap:anywhere]",
        "[&>div]:inline-block [&>div]:w-fit [&>div]:max-w-full [&>div]:min-w-0 [&>div]:align-top",
        className,
      )}
    >
      {children}
      {meta}
    </span>
  );
}
